import {
  Box,
  Button,
  Stack,
  Typography,
  useTheme,
  Chip,
  Theme,
  lighten,
} from "@mui/material";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { EventPackage } from "@/global/store/data/types";

type StaticBuildYourOwnProps = {
  title: string;
  description: string;
  minEventSelectionCount: number;
  onSelect: (pkg: EventPackage) => void;
};

export function StaticBuildYourOwn(props: StaticBuildYourOwnProps) {
  const theme = useTheme();
  const style = useStyles(theme);
  const { sm: smDown } = useCssMediaQuery("down");

  const staticPackage: EventPackage = {
    id: 100000001,
    title: props.title,
    description: props.description,
    isBuildYourOwn: true,
    minEventSelectionCount: props.minEventSelectionCount,
    events: [],
  };

  return (
    <Stack
      p={4}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      width={"100%"}
      border={`1px solid ${theme.palette.divider}`}
      borderRadius={1}
      flexWrap={"wrap"}
      gap={2}
      bgcolor={theme.palette.background.paper}
      sx={style.root}
      onClick={() => props.onSelect(staticPackage)}
    >
      <Box>
        <Typography variant="h6" color={"text.primary"} fontWeight={"700"}>
          {props.title}
        </Typography>

        <Typography variant="body1" color="text.secondary" mt={0.5}>
          {props.description}
        </Typography>
      </Box>
      <Box width={smDown ? "100%" : "fit-content"}>
        <Chip
          onClick={() => props.onSelect(staticPackage)}
          label={
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <span>{"Choose Your Games"}</span>
              <ArrowRightAltRoundedIcon
                className="arrow-icon"
                color={"inherit"}
              />
            </Stack>
          }
          clickable
          variant={"outlined"}
          color={"default"}
          size="large"
          sx={{
            fontWeight: "600",
            width: "100%",
            height: "48px",
            fontSize: "1rem",
          }}
        />
      </Box>
    </Stack>
  );
}

function useStyles(theme: Theme) {
  const primaryColor = theme.palette.primary.main;
  const hoverShadowColor = lighten(primaryColor, 0.8);
  return {
    root: {
      transition: "all 0.2s ease",
      cursor: "pointer",

      "& .arrow-icon": {
        transition: "all 0.2s ease-in-out",
      },

      "&:hover": {
        transform: `scale(1.01)`,
        boxShadow: `0 0 0 6px ${hoverShadowColor}`,

        "& .arrow-icon": {
          transform: "translateX(6px) scale(1.1)",
        },

        [theme.breakpoints.down("sm")]: {
          transform: "none",
        },
      },
    },
  };
}
